var selectStyle = {"z-select":"z-select","z-select--readonly":"z-select--readonly","z-select__arrow":"z-select__arrow"};

export { selectStyle as default };
//# sourceMappingURL=Select.module.scss.js.map
